import { CSSProperties } from "react"
import { C, radius, shadow } from "@/theme/newDesignTokens"
import { BRAND_NAME, LOGO_SRC } from "@/utils/brand"
import { t } from "i18next"

const styles: Record<string, CSSProperties> = {
    page: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: C.pageBg,
        padding: 24,
    },
    card: {
        backgroundColor: C.white,
        borderRadius: radius.xl,
        boxShadow: shadow.md,
        maxWidth: 480,
        width: "100%",
        padding: 48,
        textAlign: "center",
    },
    logo: {
        height: 40,
        objectFit: "contain",
        marginBottom: 24,
    },
    heading: {
        fontSize: "1.5rem",
        fontWeight: 700,
        color: C.navyDark,
        margin: "0 0 12px",
    },
    paragraph: {
        fontSize: "0.95rem",
        lineHeight: 1.6,
        color: C.medGray,
        margin: "0 0 8px",
    },
    button: {
        marginTop: 24,
        backgroundColor: C.navy,
        color: C.white,
        border: "none",
        borderRadius: radius.md,
        padding: "12px 32px",
        fontSize: 14,
        fontWeight: 600,
        cursor: "pointer",
    },
}

export function FallbackErrorComponent() {
    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <img src={LOGO_SRC} alt={BRAND_NAME} style={styles.logo} />
                <h2 style={styles.heading}>{t("Something went wrong")}</h2>
                <p style={styles.paragraph}>
                    {t("We hit an unexpected error. Our team has been notified and is looking into it.")}
                </p>
                <p style={styles.paragraph}>{t("Please return to the homepage to continue.")}</p>
                <button style={styles.button} onClick={() => (window.location.href = "/")}>
                    {t("Go to Homepage")}
                </button>
            </div>
        </div>
    )
}
